<table class="details-table">
  <thead>
    <tr>
      <th class="controls-cell"></th>
      <th class="index"></th>
      <th class="position">Position</th>
      <th class="price">Preis</th>
    </tr>
  </thead>
  <tbody (mouseleave)="onTableBodyMouseLeave()">
    <tr>
      <td class="!k-p-0" colspan="4">
        <table class="{{ SortableContainerCSSClass }} k-w-full k-border-separate">
          <tbody>
            @if (sortableRowsStorageService.positions().length === 0) {
              <tr class="{{ SortableRowCSSClass }} k-pos-relative">
                <td class="controls-cell">
                  <ng-container
                    [ngTemplateOutlet]="rowControlsTpl"
                    [ngTemplateOutletContext]="{
                      invoicePosition: this.buildDefaultInvoicePosition(0),
                      index: -1,
                    }"
                  />
                </td>
              </tr>
            }

            @for (
              position of sortableRowsStorageService.positions();
              track position.id;
              let i = $index
            ) {
              <tr
                appSortableRow
                [dragHelperContent]="position.description"
                [clonedDataSource]="sortableRowsStorageService.clonedPositions()"
                (rowDragStarted$)="onRowDrag()"
                (rowDrop$)="onRowDrop($event)"
                class="{{ SortableRowCSSClass }} {{ CssDropzone }} k-pos-relative"
                (mouseenter)="onRowMouseEnter(i)"
                [attr.data-item-id]="position.id"
                [attr.data-sorted-index]="i"
                [attr.data-pos-y]="0"
              >
                <td class="controls-cell">
                  @if (!currentlyDragging()) {
                    <ng-container
                      [ngTemplateOutlet]="rowControlsTpl"
                      [ngTemplateOutletContext]="{
                        invoicePosition: position,
                        index: i,
                      }"
                    />
                  }
                </td>
                <td class="index">{{ i + 1 | number: "2.0" }}</td>
                <td
                  class="description"
                  [innerHtml]="position.description | safeHtml: SecurityContext.HTML"
                ></td>
                <td class="price">
                  {{ position.price | currency: "EUR" : "symbol" : "1.2-2" }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </td>
    </tr>
    <tr class="invoice-totals" (mouseenter)="draggedRowIndex.set(null)">
      <td class="controls-cell"></td>
      <td class="index"></td>
      <td class="position !k-text-right">
        <span class="k-d-block k-pr-6">NETTO</span>
      </td>
      <td class="price">
        {{ invoice().netAmount | currency: "EUR" : "symbol" : "1.2-2" }}
      </td>
    </tr>
    <tr class="invoice-totals" (mouseenter)="draggedRowIndex.set(null)">
      <td class="controls-cell"></td>
      <td class="index"></td>
      <td class="position !k-text-right">
        <span class="k-d-block k-pr-6">UMSATZSTEUER ({{ invoice().taxRate }}%)</span>
      </td>
      <td class="price">
        {{ invoice().taxAmount | currency: "EUR" : "symbol" : "1.2-2" }}
      </td>
    </tr>
    <tr class="invoice-totals" (mouseenter)="draggedRowIndex.set(null)">
      <td class="controls-cell"></td>
      <td class="index"></td>
      <td class="position !k-text-right">
        <span class="k-d-block k-pr-6 k-font-weight-semibold">GESAMT</span>
      </td>
      <td class="price">
        <b>{{ invoice().totalAmount | currency: "EUR" : "symbol" : "1.2-2" }}</b>
      </td>
    </tr>
  </tbody>
</table>

<ng-template #rowControlsTpl let-invoicePosition="invoicePosition" let-index="index">
  <div
    class="controls controls-left k-pos-absolute k-d-flex k-flex-col k-px-2"
    [ngClass]="{ 'one-row': renderedInvoicePositions().length === 1 }"
    [@fadeOnHover]="index === -1 || draggedRowIndex() === index ? 'visible' : 'hidden'"
  >
    @if (invoicePosition !== null && renderedInvoicePositions().length > 1) {
      <button
        kendoButton
        rounded="full"
        themeColor="base"
        class="drag-entry icon-button k-button k-button-solid-base white"
        (pointerdown)="dragPosition(invoicePosition)"
      >
        <fa-icon class="icon white" size="xs" [icon]="faGridHorizontal" [rotate]="90"></fa-icon>
      </button>
    }
    <button
      kendoButton
      rounded="full"
      themeColor="base"
      class="add-entry icon-button k-button k-button-solid white"
      (click)="
        sortableRowsStorageService.addPosition(invoicePosition, buildDefaultInvoicePosition(-1))
      "
    >
      <fa-icon class="icon white" size="xs" [icon]="faPlus"></fa-icon>
    </button>
  </div>
  @if (invoicePosition !== null) {
    <div
      class="controls controls-right k-pos-absolute k-d-flex k-flex-col k-px-2"
      [@fadeOnHover]="draggedRowIndex() === index ? 'visible' : 'hidden'"
    >
      <button
        kendoButton
        rounded="full"
        themeColor="base"
        class="edit-entry icon-button k-button k-button-solid white"
        (click)="editPosition(invoicePosition)"
      >
        <fa-icon class="icon white" size="xs" [icon]="faEdit"></fa-icon>
      </button>
      <button
        kendoButton
        rounded="full"
        themeColor="base"
        class="remove-entry icon-button k-button k-button-solid-error-filled"
        (click)="sortableRowsStorageService.removePosition(invoicePosition)"
      >
        <fa-icon class="icon white" size="xs" [icon]="faTrash"></fa-icon>
      </button>
    </div>
  }
</ng-template>
